// Events are prefixed automatically by KPIAnalyticsProvider
export const KPI_EVENTS = {
  TAB_SELECTED: "Tab Selected",
  TAB_CHANGED: "Tab Changed",
  SECTION_TOGGLED: "Section Toggled",
  GROUP_SELECTED: "Group Selected",
  GROUP_CHANGED: "Group Changed",
} as const

export type KPIEventName = typeof KPI_EVENTS[keyof typeof KPI_EVENTS]
